const awsmobile = {
  Auth: {
    region: 'us-east-1',
    userPoolId: 'us-east-1_g56cKTbnT',
    userPoolWebClientId: '4sd7pj4vo89nlg9dkpn9pmere7',
  },
  aws_project_region: 'us-east-1',
  // aws_cognito_identity_pool_id:
  //   'us-east-1:275f4420-90e8-470b-8224-2f64e3fd8657',
  aws_cognito_region: 'us-east-1',
  aws_user_pools_id: 'us-east-1_g56cKTbnT',
  aws_user_pools_web_client_id: '4sd7pj4vo89nlg9dkpn9pmere7',
  oauth: {},
  aws_cognito_username_attributes: [],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ['EMAIL'],
  aws_cognito_mfa_configuration: 'OFF',
  aws_cognito_mfa_types: ['SMS'],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ['EMAIL'],
};
export default awsmobile;
